// The three states every data screen has. Centralised so "loading", "nothing
// here" and "it broke" never get invented ad hoc per route — and so an error
// always says what to do next rather than just what went wrong.

import type { ReactNode } from 'react'
import { ApiError } from '../api/client'

export function Loading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="state" role="status" aria-live="polite">
      <div className="spinner" />
      <p>{label}</p>
    </div>
  )
}

export function Empty({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="state">
      <h3>{title}</h3>
      {children ? <p>{children}</p> : null}
    </div>
  )
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const api = error instanceof ApiError ? error : null

  let title = 'Something went wrong'
  let detail = error instanceof Error ? error.message : String(error)

  if (api?.status === 0) {
    title = 'Can’t reach the CRM'
    detail = 'Check your connection. If the CRM was just updated, it will be back in a minute — try again.'
  } else if (api?.isForbidden) {
    title = 'Not available on your account'
    detail =
      'Loan and partner data is admin/manager only until loan officers ' +
      'are mapped to CRM users.'
  } else if (api?.status === 404) {
    title = 'Not found'
  }

  return (
    <div className="state error">
      <h3>{title}</h3>
      <p>{detail}</p>
      {onRetry ? (
        <p style={{ marginTop: 14 }}>
          <button className="btn sm" onClick={onRetry}>
            Try again
          </button>
        </p>
      ) : null}
    </div>
  )
}
